import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

import * as Icon from 'react-icons/md';
import { IconType } from 'react-icons';

/**
 * Loop through all of the Icons from react-icons/md and
 * wrap them in our Chakra Box. With this we can use our
 * theme values as inputs/props to the icons for layout and
 * styling
 */

export type MdIconProps = BoxProps & {
  name: string;
};

const MdIcon: React.FC<MdIconProps> = ({ name, ...props }) => {
  return <Box as={WrappedIcon[name]} {...props} />;
};

const WrappedIcon = Object.keys(Icon).reduce(
  (
    acc: {
      [key: string]: IconType;
    },
    key
  ) => {
    // @ts-ignore - can't index an imported module
    const icon: IconType = Icon[key];
    // Remove the prepended 'Md' from all Icon names
    const cleanKey = key.replace('Md', '');
    // Add the modified Icon ready for export
    acc[cleanKey] = icon;
    return acc;
  },
  {}
);

export default MdIcon;
